import React, { Component } from 'react';
import Carousel from 'react-bootstrap/Carousel';

import image1 from "../../banners/1.webp";
import image2 from "../../banners/2.webp";
import image3 from "../../banners/3.webp";
import image4 from "../../banners/4.webp";
import image5 from "../../banners/5.webp";
import { Link } from 'react-router-dom';

class Banner1 extends Component {
  render() {
    return (
      <Carousel
        nextIcon={''}
        prevIcon={''}
        nextLabel={''}
        prevLabel={''}
        style={{ width: '100%' }}
      >
          <Carousel.Item >
              <img
                className="d-block w-100"
                src={image1}
                alt="To the last Detail Okamura"
              />
          </Carousel.Item>
          <Carousel.Item >
              <img
                className="d-block w-100"
                src={image2}
                alt="Okamura Lives"
              />
          </Carousel.Item>
          <Carousel.Item >
              <img
                className="d-block w-100"
                src={image3}
                alt="To the last Detail Okamura"
              />
          </Carousel.Item>
          <Carousel.Item >
            <Link to="/Greenwave">
              <img
                className="d-block w-100"
                src={image4}
                alt="Okamura Sustentabilidad"
              />
            </Link>
          </Carousel.Item>
          <Carousel.Item >
              <img
                className="d-block w-100"
                src={image5}
                alt="Garantias Okamura"
              />
          </Carousel.Item>
      </Carousel>
    );
  }
}

export default Banner1